import { useNavigate, useSearchParams } from 'react-router-dom';
import '../App.css';
import V2Card from '../V2Card';

function DeviceMenu() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const menuItems = [
        {
            title: 'Campaigns',
            link: '/device/campaigns/',
            active: true,
        },
        {
            title: 'Install',
            link: '/devices/how_to_connect/',
            active: true,
        },
        {
            title: 'Statistics',
            link: '/device/stats/',
            active: true,
        },
        {
            title: 'Pricing',
            link: '/device/pricing/',
            active: false,
        },
        {
            title: 'Monetize',
            link: '/device/monetize/',
            active: false,
        },
    ]

    const divMenuItems = menuItems.map(
        m =>
            <div
                style={{
                    cursor: 'pointer',
                    marginLeft: '2em',
                    color: !m.active ? 'grey' : null,
                }}
                onClick={
                    () => {
                        if (!m.active) {
                            return;
                        }

                        navigate(`${m.link}?device_id=${searchParams.get('device_id')}`)
                    }
                }
            >
                <b>
                    {
                        window.location.pathname == m.link &&
                        <div className='sub-menu-item-selected'>
                            {m.title}
                        </div>
                    }
                    {
                        window.location.pathname != m.link &&
                        <div className='sub-menu-item'>
                            {m.title}
                        </div>
                    }
                </b>
            </div>
    )

    return (
        <V2Card>
            <div
                align='left'
                style={{ width: '90%', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}
            >
                {divMenuItems}
            </div>
        </V2Card>
    );
}

export default DeviceMenu;